<template>
    <div class="addpet" ref='addpet'>
        <addpetType v-if="selpetType" @petsN='getpetType'></addpetType>
        <header-top :goBack="true" :mine = 'true'></header-top>
        <div class="title" ref='title'>
            <p class="addtext">{{$t('addpet.addpet')}}</p>
        </div>
        <div class="addpet-main" ref='wrapper'>
            <div style="height: 700px;">
                <div class="head_img">
                    <img :src="imgflag?avatar:avatar1" @click.stop="uploadHeadImg" style="margin: auto;display: block;" ref="ava" v-show="isshow" />
                    <canvas ref="can" v-show="showflag" style="width:80px;height:80px;margin: auto;display: block;border-radius: 50%;" @click.stop="uploadHeadImg"></canvas>
                    <p class="setimg">{{$t('addpet.setPetPortrait')}}</p>
                    <input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />
                </div>

                <div class="pet">
                    <ul>
                        <li>
                            <span><img src="../../../static/img/account2/petNick.png" alt="">{{$t('addpet.petName')}}</span>
                            <el-input v-model="petname" :placeholder="$t('addpet.entername')" @change="Verificationname" maxlength="12" clearable></el-input>
                            <p class="danger" v-show='flag2'>{{$t('addpet.flag2')}}</p>
                            <p class="danger" v-show='flag6'>{{$t('addpet.notpetName')}}</p>
                        </li>
                        <li>
                            <span @click="selpetsType" style="width:100%;"><img src="../../../static/img/account2/petType.png" alt="">{{$t('addpet.petType')}}</span>
                            <el-input v-model='petbelong' :placeholder="$t('addpet.enterType')" maxlength="8" readonly></el-input>
                            <p class="danger" v-show='flag3'>{{$t('addpet.enterchinese')}}</p>
                            <p class="danger" v-show='flag7'>{{$t('addpet.notpetType')}}</p>
                        </li>
                        <li>
                            <span><img src="../../../static/img/account2/petColor.png" alt="">{{$t('addpet.color')}}</span>
                            <el-input v-model='haircolor' :placeholder="$t('addpet.enterColor')" @change="Verificationhaircolor" maxlength="6" clearable></el-input>
                            <p class="danger" v-show='flag4'>{{$t('addpet.enterchinese')}}</p>
                            <p class="danger" v-show='flag8'>{{$t('addpet.notpetColor')}}</p>
                        </li>
                        <li>
                            <span><img src="../../../static/img/account2/sex.png" alt="">{{$t('addpet.sex')}}</span>
                            <el-select v-model="value" :placeholder="$t('addpet.selectSex')" @change="Verificationsex" @focus="issex" @visible-change="lesex" ref='sex'>
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <p class="danger" v-show='flag9'>{{$t('addpet.notpetSex')}}</p>
                        </li>
                        <li>
                            <span><img src="../../../static/img/account2/petWeight.png" alt="">{{$t('addpet.weight')}}(Kg)</span>
                            <el-input v-model='weight' :placeholder="$t('addpet.enterweight')" @change='addweight' type="number"></el-input>
                            <p class="danger" v-show='flag1'>{{$t('addpet.not')}}</p>
                            <p class="danger" v-show='flag10'>{{$t('addpet.notWeight')}}</p>
                        </li>
                        <!-- <li>
                            <span><img src="../../../static/img/account2/petType.png" alt="">{{$t('addpet.height')}}(CM)</span>
                            <el-input v-model='height' :placeholder="$t('addpet.enterheight')" @change='addheight' type="number"></el-input>
                            <p class="danger" v-show='flag'>{{$t('addpet.not')}}</p>
                            <p class="danger" v-show='flag11'>{{$t('addpet.notHeight')}}</p>
                        </li> -->
                        <li>
                            <span><img src="../../../static/img/account2/petBirth.png" alt="">{{$t('addpet.birthday')}}</span>
                            <div class="block">
                                <el-date-picker v-model="birthday" type="date" value-format="yyyy-MM-dd" :placeholder="$t('addpet.selectData')" :picker-options="pickerOptions" @focus='disapper' ref='datetime' @change="Verificationbirthday">
                                </el-date-picker>
                            </div>
                            <p class="danger" v-show='flag12'>{{$t('addpet.notBirthday')}}</p>
                        </li>
                        <!-- <li>
                            <span><img src="../../../static/img/account2/petType.png" alt="">{{$t('addpet.character')}}</span>
                            <el-input v-model="character" :placeholder="$t('addpet.entercharacter')" @change="Verificationcharacter" maxlength="8"></el-input>
                            <p class="danger" v-show='flag5'>{{$t('addpet.enterchinese')}}</p>
                            <p class="danger" v-show='flag13'>{{$t('addpet.notcharacter')}}</p>
                        </li> -->
                    </ul>
                    <div class="save-btn">
                        <el-button type="primary" @click='add' :disabled='issub'>{{msg}}</el-button>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import IScroll from "iscroll/build/iscroll-probe";
import axios from "axios";
import headerTop from "../../components/header";
import addpetType from "../myAccount/addpetType"
import { getpet, addPet } from "../../ClientServerApi/index.js";
import {getLoginUser} from "../../api/index.js";
import Qs from "qs";
import EXIF from "exif-js/exif.js";
export default {
    name: "addpet",
    inject: ["reload"],
    data() {
        return {
            src: "",
            petname: "",
            petbelong: "",
            height: "",
            weight: "",
            birthday: "",
            haircolor: "",
            character: "",
            avatar: "",
            avatar1: require("../../image/addpet1.png"),
            portrait: "",
            imgflag: false,
            showflag: false,
            isshow: true,
            maxweight: "",
            maxheight: "",
            value: "",
            issub: false,
            msg: this.$t("addpet.trueAdd"),
            cmsg: this.$t("addpet.submiting"),
            tmsg: this.$t("addpet.trueAdd"),
            Height: "",
            selpetType: false,
            options: [
                {
                    value: this.$t("prompt.boy"),
                    label: this.$t("prompt.boy")
                },
                {
                    value: this.$t("prompt.girl"),
                    label: this.$t("prompt.girl")
                }
            ],
            flag: false,
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: false,
            flag5: false,
            flag6: false,
            flag7: false,
            flag8: false,
            flag9: false,
            flag10: false,
            flag11: false,
            flag12: false,
            flag13: false,
            scrollY:0,
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > Date.now();
                }
            }
        };
    },
    components: {
        headerTop,
        addpetType
    },
    created() {
        this.Height =
            document.documentElement.clientHeight || document.body.clientHeight;
         this.$nextTick(() => {
            this._initScroll()
        });
        //检验是否登录超时
        if (sessionStorage.getItem("login") == 1) {
        getLoginUser()
            .then(res => {
            if (res.data.header.status == 3019) {
                sessionStorage.setItem("login", "1");
                this.$message({
                type: "success",
                message: this.$t("prompt.header")
                });
                this.$router.push("/login");
            }
            })
            .catch(err => {});
        }
    },
    watch:{
        petbelong(newvalue, oldvalue){
            this.$nextTick(function() {
				if(newvalue==''){
                    this.flag7 = true
                }else{
                    this.flag7 = false
                }
			})
        }
    },
    mounted() {

        this.$refs.addpet.style.height = this.Height + "px";
        this.$refs.wrapper.style.height = this.Height - 40 + "px";
        this.$refs.wrapper.style.top =
        this.$refs.title.offsetHeight + 40 + "px";
    },
    methods: {
        _initScroll(){
            this.Scroll = new IScroll(this.$refs.wrapper, {
                click: true,
                probeType: 3
            });
            let self = this
            this.Scroll.on('scroll',function(){
                self.scrollY = this.y
            },true)
        },
        //点击触发input上传事件
        uploadHeadImg: function() {
            // console.log('点击触发input事件')
            this.$el.querySelector(".hiddenInput").click();
        },
        // 将头像显示
        handleFile: function(e) {
            // console.log("上传图片")
            var th = this;
            th.imgflag = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag = false;
                    th.isshow = true;
                    th.avatar = res.result;
                    th.portrait = data.target.result.split(",")[1];
                } else {
                    th.compress(res.result, Orientation);
                }
            };
        },
        compress(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag = true;
            th.isshow = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                var canvas = th.$refs.can;
                var ctx = canvas.getContext("2d");
                canvas.width = width;
                canvas.height = height;
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.portrait = base64.split(",")[1];
                th.avatar = base64.result;
            };
        },
        //验证宠物名称
        Verificationname() {
            if (this.petname.length == 0) {
                this.flag2 = false;
            } else {
                this.flag6 = false;
            }
        },
        //获取宠物品种
        selpetsType(){
            this.selpetType = true;
        },
        getpetType(data){//获取宠物列表组件传来数据
            // console.log("get pet type:",data)
            this.selpetType = false;
            this.petbelong = data.id;
        },
        //验证宠物品种
        Verificationbelong() {
            console.log(this.petbelong)
            if (this.petbelong=="") {
                this.flag3 = false;
                this.flag7 = true;
            } else {
                this.flag3 = false;
                this.flag7 = false;
            }
        },
        //验证宠物毛色
        Verificationhaircolor() {
            if (this.haircolor.length == 0) {
                this.flag4 = false;
            } else {
                this.flag8 = false;
            }
        },
        //验证宠物性格
        Verificationcharacter() {
            if (this.character.length == 0) {
                this.flag5 = false;
            } else {
                this.flag13 = false;
            }
        },
        //验证出生日期
        Verificationbirthday() {
            if (this.birthday.length > 0) {
                this.flag12 = false;
            }
        },
        Verificationsex() {
            if (this.value.length > 0) {
                this.flag9 = false;
            }
        },
        issex(){
            this.Scroll.destroy()
        },
        lesex(e){
            if(e==false){
            this._initScroll()
            this.Scroll.scrollTo(0, this.scrollY)
            this.$refs.sex.blur()
            }
        },
        //验证宠物身高
        addheight() {
            let reg = /(^[0-9]{1,3}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/;
            if (reg.test(this.height)) {
                this.flag = false;
            } else {
                this.flag = true;
            }
            if (this.height.length == 0) {
                this.flag = false;
            } else {
                this.flag11 = false;
            }
        },
        //验证宠物体重
        addweight() {
            let reg = /(^[0-9]{1,3}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/;
            if (reg.test(this.weight)) {
                this.flag1 = false;
            } else {
                this.flag1 = true;
            }
            if (this.weight.length == 0) {
                this.flag1 = false;
            } else {
                this.flag10 = false;
            }
        },
        disapper() {
            this.$refs.datetime.blur();
        },
        add() {
            // console.log('33333333333')
            if (this.petname.length == 0) {
                this.flag6 = true;
            }
            if (this.petbelong.length == 0) {
                this.flag7 = true;
            }
            if (this.haircolor.length == 0) {
                this.flag8 = true;
            }
            if (this.value == "") {
                this.flag9 = true;
            }
            if (this.weight.length == 0) {
                this.flag10 = true;
            }
            this.addweight()
            // if (this.height.length == 0) {
            //     this.flag11 = true;
            // }
            // this.addheight()
            if (this.birthday.length == 0) {
                this.flag12 = true;
            }
            // if (this.character.length == 0) {
            //     this.flag13 = true;
            // }
            if (this.avatar == "") {
                this.$message({
                    type: "error",
                    message: this.$t("prompt.notpetimg")
                });
            }
            
            if (
                this.flag == false &&
                this.flag1 == false &&
                this.flag2 == false &&
                this.flag3 == false &&
                this.flag4 == false &&
                this.flag5 == false &&
                this.flag6 == false &&
                this.flag7 == false &&
                this.flag8 == false &&
                this.flag9 == false &&
                this.flag10 == false &&
                // this.flag11 == false &&
                this.flag12 == false &&
                // this.flag13 == false &&
                this.avatar != ""
            ) {
                setTimeout(() => {
                    this.msg = this.cmsg;
                    this.issub = true;
                    var params = Qs.stringify({
                        name: this.petname,
                        height: this.height,
                        weight: this.weight,
                        birthTime: this.birthday,
                        petType: this.petbelong,
                        color: this.haircolor,
                        gender: this.value,
                        portrait: this.portrait,
                        character: this.character
                    });
                    addPet(params)
                        .then(res => {
                            // console.log('上传头像后返回：',res);
                            // console.log(res);
                            if (res.data.header.status == 1000) {
                                this.issub = false;
                                if (this.$route.params.fromPage == "home") {
                                    // this.$router.push({ path: "/home" });
                                    this.$router.go(-1);
                                } else {
                                    this.$router.push({ path: "/myAccount" });
                                }

                                this.reload();
                            } else if (res.data.header.status == 80044) {
                                this.$message(this.$t("prompt.againlogin"));
                                this.msg = this.tmsg;
                                this.issub = false;
                                // alert("内容含有非法字符");
                                this.$router.push({ path: "/login" });
                                return false;
                            } else if (res.data.header.status == 80042) {
                                this.$message(this.$t("prompt.contentInteval"));
                                this.msg = this.tmsg;
                                this.issub = false;
                                // alert("内容含有非法字符");
                                return false;
                            } else if (res.data.header.status == 2000) {
                                this.msg = this.tmsg;
                                this.$message({
                                    type: "error",
                                    message: this.$t("prompt.addfailure")
                                });
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }, 100);
            }
        }
    }
};
</script>
<style>
.el-message-box {
    width: 300px;
}
.el-message {
    min-width: 60%;
}
.addpet .el-button--primary {
    /* background-color: rgb(9, 81, 150);
    border-color: rgb(9, 81, 150); */
    width: 72%;
    margin-left: 14%;
    font-size: 1rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}
.pet .el-input{
    width: 100%;
}
.pet .el-input .el-input__inner{
    width: 100%;
    box-sizing: border-box;
    border: 0;
    border-bottom: 1px solid #cccccc;
    border-radius: 0;
    text-align: right;
    padding: 0 1rem 0 8rem;
    height: 2.6rem;
    line-height: 2.6rem;
    background: transparent;
}
.pet .el-select{
    width: 100%;
}
.pet .el-input__icon{
    display: none;
}

</style>
<style scoped>
@media screen and (max-width: 321px) {
    /* .pet span{
        font-size: 0.78rem !important;
    } */
}
.addpet .danger {
    font-size: 0.625rem;
    color: red;
    margin-top: 5px;
    margin-left: 1rem;
}
.addtext {
    text-align: center;
    font-size: 0.8rem;
    color: rgb(130, 130, 130);
    padding-top: 5px;
}
.head_img {
    margin-top: 30px;
}
.head_img img {
    width: 80px;
    height: 80px;
    border-radius: 50px;
}
.setimg {
    text-align: center;
    font-size: 0.8rem;
    margin-top: 10px;
}
.hiddenInput {
    display: none;
}
.addpet {
    width: 100%;
    position: fixed;
    top:0;
}

.addpet-main {
    position: absolute;
    top: 55px;
    bottom: 0;
    width: 100%;
    max-width: 579px;
    overflow: hidden;
    touch-action: none;
}

.pet{
    border-top: 1px solid #cccccc;
    margin-top: 1rem;
}
.pet ul li{
    width: 100%;
    list-style: none;
    position: relative;
}
.pet ul li span{
    position: absolute;
    z-index: 99;
    width: 7rem;
    left: 1rem;
    display: block;
    height: 2.6rem;
    line-height: 2.6rem;
    font-size: 0.8rem;
}
.pet ul li span img{
    width: 1rem;
    vertical-align: middle;
    margin-right: 0.5rem;
}


</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/addpet.vue